import { useRef, useState } from "react";
import { Paperclip, Send, FileText } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { errMsg } from "@/lib/api";
import { fileSize, uploadAttachment } from "@/lib/media";

const ACCEPT = "image/jpeg,image/png,image/webp,application/pdf,.doc,.docx,.xls,.xlsx,.txt,audio/*";

export const AttachmentButton = ({ cid, disabled, onSent }) => {
  const ref = useRef(null);
  const [file, setFile] = useState(null);
  const [caption, setCaption] = useState("");
  const [busy, setBusy] = useState(false);
  const isImage = file?.type.startsWith("image/");

  const send = async () => {
    setBusy(true);
    try {
      const { data } = await uploadAttachment(cid, file, caption);
      if (data.delivery === "failed") toast.error(`Invio WhatsApp fallito: ${data.error}`);
      setFile(null); setCaption(""); onSent();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  return (
    <>
      <input ref={ref} type="file" accept={ACCEPT} className="hidden" data-testid="attachment-file-input"
        onChange={(e) => { const f = e.target.files?.[0]; e.target.value = ""; if (f && f.size > 16 * 1048576) return toast.error("File troppo grande (max 16MB)"); setFile(f || null); }} />
      <button data-testid="attachment-button" type="button" disabled={disabled} onClick={() => ref.current?.click()} title="Allega foto o documento"
        className="h-11 w-11 rounded-full grid place-items-center text-slate-500 hover:bg-slate-100 hover:text-slate-800 transition-colors disabled:opacity-40">
        <Paperclip size={18} />
      </button>
      <Dialog open={!!file} onOpenChange={(o) => !o && setFile(null)}>
        <DialogContent data-testid="attachment-preview-dialog">
          <DialogHeader>
            <DialogTitle>Invia allegato</DialogTitle>
            <DialogDescription>{file?.name} · {fileSize(file?.size)}</DialogDescription>
          </DialogHeader>
          {file && (isImage ? (
            <img src={URL.createObjectURL(file)} alt="anteprima" className="rounded-lg max-h-80 w-full object-contain bg-slate-100" />
          ) : (
            <div className="flex items-center gap-3 bg-slate-50 border border-slate-200 rounded-lg p-4">
              <FileText className="text-red-500" /> <span className="text-sm font-medium truncate">{file.name}</span>
            </div>
          ))}
          <Input data-testid="attachment-caption-input" placeholder="Aggiungi una didascalia (opzionale)" value={caption} onChange={(e) => setCaption(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && send()} />
          <Button data-testid="attachment-send-button" disabled={busy} onClick={send} className="bg-[#25D366] hover:bg-[#22C55E] text-white">
            <Send size={15} className="mr-1.5" />{busy ? "Invio in corso…" : "Invia"}
          </Button>
        </DialogContent>
      </Dialog>
    </>
  );
};
